import { render, staticRenderFns } from "./SMSTemplates.vue?vue&type=template&id=3d1e518a&"
import script from "./SMSTemplates.vue?vue&type=script&lang=ts&"
export * from "./SMSTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports